import { Component, Input, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TOPBAR } from "../layouts.model";
import { EventService } from '../../core/services/event.service';
import { ValidatorsService } from 'src/app/services/validators.service';


import { HorizontaltopbarComponent } from '../horizontaltopbar/horizontaltopbar.component';
import { RightsidebarComponent } from '../rightsidebar/rightsidebar.component';
import { FooterComponent } from '../footer/footer.component';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { ToastModule } from 'primeng/toast';
import { SubscriptionAlertBannerComponent } from 'src/app/core/components/subscription-alert-banner/subscription-alert-banner.component';
import { ModalRefreshTokenComponent } from 'src/app/pages/management/user-profile/components/modal-refresh-token/modal-refresh-token.component';

@Component({
  selector: 'app-horizontal',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    HorizontaltopbarComponent,
    RightsidebarComponent,
    FooterComponent,
    BreadcrumbComponent,
    ToastModule,
    SubscriptionAlertBannerComponent,
    ModalRefreshTokenComponent
  ],
  templateUrl: './horizontal.component.html',
  styles: [],
})
export class HorizontalComponent implements OnInit {
  topbar = signal(TOPBAR);
  eventService = inject(EventService);
  validatorsService = inject(ValidatorsService);

  @Input() breadcrumbs: any = [];
  ngOnInit(): void {
    this.eventService.subscribe('changeTopbar', (topbar) => {
      this.topbar.set(topbar);
      this.changeTopbar(this.topbar());
    });

    document.body.setAttribute('data-layout', 'horizontal');
    document.body.removeAttribute('data-sidebar');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-keep-enlarged');
    document.body.removeAttribute('data-sidebar-small');

    this.changeTopbar(this.topbar());
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
  }

  changeTopbar(topbar: string) {
    switch (topbar) {
      case "light":
        document.body.setAttribute("data-topbar", "light");
        break;
      case "dark":
        document.body.setAttribute("data-topbar", "dark");
        break;
      case "colored":
        document.body.setAttribute("data-topbar", "colored");
        break;
      default:
        document.body.setAttribute("data-topbar", "dark");
        break;
    }
  }

}
